import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["track", "dot", "videoSlide", "frame"]

  connect() {
    this.updateDots()
  }

  onScroll() {
    this.updateDots()
  }

  goTo(event) {
    this.scrollToIndex(parseInt(event.currentTarget.dataset.index, 10))
  }

  previous() {
    this.scrollToIndex(this.currentIndex() - 1)
  }

  next() {
    this.scrollToIndex(this.currentIndex() + 1)
  }

  // Wraps around, so "next" on the last slide goes back to the first.
  scrollToIndex(index) {
    const count = this.trackTarget.children.length
    const wrapped = (index + count) % count
    this.trackTarget.scrollTo({ left: wrapped * this.trackTarget.clientWidth, behavior: "smooth" })
  }

  currentIndex() {
    if (this.trackTarget.clientWidth === 0) return 0
    return Math.round(this.trackTarget.scrollLeft / this.trackTarget.clientWidth)
  }

  disconnect() {
    this.closePlayer()
  }

  playVideo(event) {
    if (this.overlay) return
    const overlay = document.createElement("div")
    overlay.className = "pa-media-lightbox"

    const iframe = document.createElement("iframe")
    iframe.src = event.currentTarget.dataset.videoSrc
    iframe.allow = "autoplay; encrypted-media; picture-in-picture"
    iframe.allowFullscreen = true

    const close = document.createElement("button")
    close.type = "button"
    close.className = "pa-media-lightbox-close"
    close.setAttribute("aria-label", "Fermer la vidéo")
    close.innerHTML = "&times;"
    close.addEventListener("click", () => this.closePlayer())

    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) this.closePlayer()
    })

    overlay.appendChild(iframe)
    overlay.appendChild(close)
    document.body.appendChild(overlay)
    this.overlay = overlay
  }

  closePlayer() {
    if (this.overlay) {
      this.overlay.remove()
      this.overlay = null
    }
  }

  updateDots() {
    const index = this.currentIndex()
    this.dotTargets.forEach((dot, i) => dot.classList.toggle("active", i === index))
    const slides = Array.from(this.trackTarget.children)
    const onVideoSlide = this.videoSlideTargets.some((slide) => slides.indexOf(slide) === index)
    if (!onVideoSlide) this.closePlayer()
  }
}
